const makeString = (object: string) => {
    if (object == null) {
        return '';
    }

    return String(object);
};

export default makeString;
